module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.e79bfd88.eot";